import PageMixins from "../../JComponents/JPage/mixins/PageMixins";
import PaginationMixins from "../../JComponents/JPage/mixins/PaginationMixins";
import DialogMixins from "../../JComponents/JPage/mixins/DialogMixins";
import ruleMixins from "../RuleForm/ruleMixins";

import JEllipsis from "../../JComponents/JEllipsis/JEllipsis";
import JGridCtrl from "../../JComponents/JGridCtrl/JGridCtrl";
import JSensitive from "../../JComponents/JSensitive/JSensitive";
import JDictionary from "../../JComponents/JDictionary/JDictionary";
import JAddress from "../../JComponents/JAddress/JAddress";

import RuleForm from "../RuleForm/RuleForm";
import TrendSearch from "./search/TrendSearch";

export default {
    mixins: [PageMixins, PaginationMixins, DialogMixins, ruleMixins],
    components: {
        RuleForm,
        JEllipsis,
        JGridCtrl,
        JSensitive,
        JDictionary,
        JAddress,
        TrendSearch
    },
    data () {
        return {
            pageLoading: true,
            showSearch: false,
            conds: [],
            tableCell: []
        }
    },
    created () {
        this.getFormFields()
        this.getTableCell()
    },
    methods: {
        widthStyle (column) {
            // if (column.caseFieldName === 'gridCode') return 450
            return this.tableCell.length > 15 ? column.fieldName.length * 10 + 60:'0'
        },
        resetComplexSearch () {
            this.$refs['ComplexSearchDom'] && this.$refs['ComplexSearchDom'].setGetGroup([])
            this.conds = []
        },
        complexSearch () {
            this.conds = this.$refs['ComplexSearchDom'] && this.$refs['ComplexSearchDom'].getGroupFlat().conds
            this.showSearch = false
            this.load()
        },
        addDgmxEvent() {
            this.dgmxType = 'ADD'
            this.renderHandle(this.formList, this.forms, this.rules, this.loadDic)
            this.showDgmx = true
        },
        async detailDgmxEvent(row) {
            this.dgmxType = 'DET'
            this.curItem = await this.getDetailMetaData(`/api/dynamicLedgerManages/${this.ledgerId}/info/${row.id}`) // 函数定义在PageMixins中
            this.renderHandle(
                this.formList,
                this.forms,
                this.rules,
                this.loadDic,
                this.curItem
            )
            this.showDgmx = true
        },
        async editDgmxEvent(row) {
            this.dgmxType = 'EDIT'
            this.curItem = await this.getDetailMetaData(`/api/dynamicLedgerManages/${this.ledgerId}/info/${row.id}`) // 函数定义在PageMixins中
            this.renderHandle(
                this.formList,
                this.forms,
                this.rules,
                this.loadDic,
                this.curItem
            )
            this.showDgmx = true
        },
        async saveDgmxData(formData) {
            if (this.submitLoad) return
            this.submitLoad = true
            let method = 'post'
            let url = `/api/dynamicLedgerManages/${this.ledgerId}/insert`
            if (this.dgmxType === 'EDIT') {
                url = `/api/dynamicLedgerManages/${this.ledgerId}/update/${this.curItem.id}`
                method = 'put'
            }
            const { data } = await this.$http[method](url, formData)
                .catch(({ response }) => {
                    this.$message.error(response.data.msg)
                })
                .finally(() => {
                    this.submitLoad = false
                })
            if (data.status !== 'yes') return this.$message.error(data.msg)
            this.showDgmx = false
            this.$message.success('提交成功')
            this.load()
        },
        // 获取采集字段
        async getFormFields () {
            const { data } = await this.$http.get(
                `/api/fieldModels/${this.ledgerId}/listFieldsOfInput`
            )
            this.formList = data.data
            this.renderHandle(this.formList, this.forms, this.rules, this.loadDic)
        },
        async getTableCell () {
            const { data } = await this.$http.get(`/api/dynamicLedgerManages/listFieldsOfPageData/${this.ledgerId}`)
            if (data.status !== 'yes') return this.$message.error(data.msg || data.message || '获取表头数据异常')
            this.tableCell = data.data
            this.load()
        },
        async load () {
            this.tableLoading = true
            const { data } = await this.$http.request({
                method: 'post',
                url: `/api/dynamicLedgerManages/${this.ledgerId}/page`,
                params: this.query,
                data: this.conds || []
            })
            this.tableData = data.data.data
            this.query.total = data.data.total
            this.tableLoading = false
            this.pageLoading = false
        },
        delEvent (row) {
            this.$confirm('您确认要删除当前记录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.request({ method: 'delete', url: `/api/dynamicLedgerManages/${this.ledgerId}/delete/${row.id}`})
                    .then((res) => {
                        if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                        this.pageUpdate(this.query)
                        this.$message.success('删除成功')
                        this.load && this.load()
                    })
            })
        },
        searchEvent () {
            this.query.page = 1
            const { conds, query } = this.$refs.searchDom.getFormData()
            this.conds = conds
            this.query = { ...this.query, ...query }
            this.load && this.load()
        },
        resetEvent () {
            // 重置query对象
            this.$refs.searchDom.resetFormData()
            this.query = { ...this.$options.data().query }
            this.conds = []
            this.load && this.load()
        },
        async exportEvent () {
            const { data } = await this.$http.request({
                method: 'post',
                url: `/api/real-people-label/ledger/export/${this.ledgerId}`,
                params: this.query,
                data: this.conds || [],
                responseType: 'arraybuffer',
                notProcessed: true // axios不统一处理请求返回操作
            })
            let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', this.labelOption.menu.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link) // 下载完成移除元素
            window.URL.revokeObjectURL(url) // 释放掉blob对象
        }
    }
}
